import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { RxCross2 } from "react-icons/rx";
import { FaBirthdayCake, FaBuilding, FaEnvelope, FaPhone } from "react-icons/fa";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Getintouch from "./Getintouch";

interface UserDetails {
  id: number;
  name: string;
  email: string;
  role: string;
  company_name: string;
  profile: string;
  point: number;
  Time: string;
  DOB: string;
  number: number;
}

const AllBirthdays = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [userdetails, setUserdetails] = useState<UserDetails[]>([]);
  const [selectedUser, setSelectedUser] = useState<UserDetails | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [searchName, setSearchName] = useState("");
  const [filterMonth, setFilterMonth] = useState("");

  const currentMonth = new Date().getMonth();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  useEffect(() => {
    const fetchAllUserData = async () => {
      try {
        const response = await axios.get(`${api}/auth/allusersinfo`);
        setUserdetails(response.data);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };
    fetchAllUserData();
  }, [api]);

  const openModal = (user: UserDetails) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  const birthdayUsersThisMonth = userdetails.filter(
    (user) =>
      user.role !== "super-admin" &&
      user.DOB &&
      new Date(user.DOB).getMonth() === currentMonth
  );

  const filteredUsers = userdetails.filter((user) => {
    if (user.role === "super-admin" || !user.DOB) return false;
    const matchName = user.name.toLowerCase().includes(searchName.toLowerCase());
    const dobMonth = new Date(user.DOB).getMonth().toString();
    const matchMonth = filterMonth === "" || filterMonth === dobMonth;
    return matchName && matchMonth;
  });

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <div className="w-full min-h-screen bg-[#0F172A] text-white">
      {/* Hero Slider Section */}
       <Header />
    

{birthdayUsersThisMonth.length > 0 && (
  <div className="w-[96%] mx-auto px-2 py-7">
    <Slider {...sliderSettings}>
      {birthdayUsersThisMonth.map((user) => {
        const dob = new Date(user.DOB);
        const dobText = `${dob.getDate()} ${monthNames[dob.getMonth()]} ${dob.getFullYear()}`;

        return (
          <div
            key={user.id}
            className="px-2"
          >
            <div className="bg-gradient-to-br from-[#fff4d8] via-[#fff] to-[#ffe9e1] rounded-3xl shadow-2xl px-6 py-10 flex flex-col md:flex-row items-center justify-center gap-8 border border-yellow-200 hover:scale-[1.02] transition-transform duration-300">
              
              {/* Decorative emoji top corner */}
              <div className="absolute text-3xl md:text-4xl left-6 top-6 animate-bounce">🎈</div>

              {/* Profile Image */}
              <div className="relative w-36 h-36 md:w-44 md:h-44 rounded-full border-[5px] border-[#fbbf24] shadow-lg bg-white overflow-hidden">
                <img
                  src={`${api}/${user.profile}`}
                  alt={user.name}
                  className="w-full h-full object-cover rounded-full"
                />
              </div>

              {/* Info */}
              <div className="text-center md:text-left space-y-2 max-w-md">
                <h2 className="text-3xl font-extrabold text-[#f59e0b]">
                  🎉 Happy Birthday, {user.name}!
                </h2>
                <p className="text-gray-700 text-lg font-medium">
                  {user.role} at {user.company_name}
                </p>
                <p className="text-gray-500 text-base">
                  🎂 <span className="font-semibold">{dobText}</span>
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </Slider>
  </div>
)}


      {/* Filter and Grid Section */}
      <div className="bg-[#1E2A3A] py-14 px-[5%]">
        <div className="bg-[#101729] rounded-xl p-6">
          <h2 className="text-2xl text-center font-semibold text-white mb-6">
            <span className="text-[#FDBC12]">All Birthdays</span>
          </h2>

          {/* Filters */}
          <div className="flex flex-col sm:flex-row gap-4 mb-6 justify-center">
            <input
              type="text"
              placeholder="Search by name"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              className="w-full sm:w-[250px] px-4 py-2 rounded-lg bg-[#1E2A3A] text-white border border-[#FDBC12] placeholder:text-gray-400"
            />
            <select
              value={filterMonth}
              onChange={(e) => setFilterMonth(e.target.value)}
              className="w-full sm:w-[200px] px-4 py-2 rounded-lg bg-[#1E2A3A] text-white border border-[#FDBC12]"
            >
              <option value="">All Months</option>
              {monthNames.map((m, i) => (
                <option key={i} value={i}>{m}</option>
              ))}
            </select>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredUsers.map((user) => {
              const dobDate = new Date(user.DOB);
              const formattedDate = `${dobDate.getDate()} ${monthNames[dobDate.getMonth()]} ${dobDate.getFullYear()}`;

              return (
                <div
                  key={user.id}
                  onClick={() => openModal(user)}
                  className="bg-[#1E2A3A] p-5 rounded-2xl border border-[#FDBC12] hover:shadow-xl hover:scale-105 cursor-pointer transition-all"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-[90px] h-[90px] rounded-full overflow-hidden border-4 border-white shadow-md mb-4">
                      <img
                        src={`${api}/${user.profile}`}
                        alt={user.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <h3 className="text-white text-lg font-semibold mb-1">{user.name}</h3>
                    <p className="text-sm text-gray-400 mb-2">{user.company_name}</p>
                    <div className="bg-[#FDBC12] text-[#1E2A3A] text-sm px-3 py-1 rounded-full font-semibold shadow-sm">
                      🎂 {formattedDate}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Modal */}
   {showModal && selectedUser && (
  <div className="fixed inset-0 bg-black bg-opacity-80 backdrop-blur-sm flex items-center justify-center z-50 px-4">
    <div className="bg-[#1E2A3A] max-w-md w-full rounded-2xl shadow-xl p-8 relative animate-fade-in border border-[#2C3E50]">
      
      {/* Close Button */}
      <button
        onClick={closeModal}
        className="absolute top-4 right-4 text-gray-400 hover:text-[#FDBC12] transition"
        aria-label="Close"
      >
        <RxCross2 size={24} />
      </button>

      {/* User Content */}
      <div className="flex flex-col items-center text-center space-y-5">
        {/* Profile Image */}
        <img
          src={`${api}/${selectedUser.profile}`}
          alt={selectedUser.name}
          className="w-28 h-28 rounded-full object-cover border-4 border-[#FDBC12] shadow-[0_0_12px_#FDBC12] transition-transform hover:scale-105"
        />

        {/* Name and Role */}
        <div>
          <h3 className="text-2xl font-semibold text-white">{selectedUser.name}</h3>
          <p className="text-sm text-gray-400">{selectedUser.role}</p>
        </div>

        {/* Info List */}
        <div className="w-full space-y-4 text-sm text-left text-gray-200">
          <div className="flex items-center gap-3">
            <FaEnvelope className="text-[#FDBC12]" />
            <span>{selectedUser.email}</span>
          </div>
          <div className="flex items-center gap-3">
            <FaPhone className="text-[#FDBC12]" />
            <span>{selectedUser.number}</span>
          </div>
          <div className="flex items-center gap-3">
            <FaBuilding className="text-[#FDBC12]" />
            <span>{selectedUser.company_name}</span>
          </div>
          <div className="flex items-center gap-3">
            <FaBirthdayCake className="text-[#FDBC12]" />
            <span>{selectedUser.DOB}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
)}



       <Getintouch />
      <Footer />
    </div>
  );
};

export default AllBirthdays;
